import ServiceBase from './ServiceBase';

class CourseService extends ServiceBase {
  async checkLimit(courseId, chapter_id) {
    let data = await this.http.get('/api/app/course/limit/visit/' + courseId, {
      chapter_id,
    });

    return new Promise((resolve) => {
      if (data.limit == 0) {
        resolve();
      } else {
        this.vue.$warning('访问被限制，请联系老师');
      }
    });
  }

  checkLiveState(course_type, period, type = 1) {
    if (course_type == 2 || course_type == 3 || course_type == 15) {
      if (period.play_type == 3 || period.play_type == 5) {
        return false;
      }
    }
    if (course_type == 16) {
      if (type == 1) {
        if (period.play_type == 3 || period.play_type == 5) {
          return false;
        }
      } else if (type == 2) {
        if (period.min_class == 0 || period.min_play_type == 3 || period.min_play_type == 5) {
          return false;
        }
      }
    }
    return true;
  }

  async watchVideo(period, periods_type, course_id, type = 1) {
    if (!this.checkLiveState(periods_type, period, type)) {
      return;
    }
    if (
      periods_type == 2 ||
      periods_type == 3 ||
      periods_type == 15 ||
      periods_type == 16 ||
      periods_type == 23
    ) {
      let params = {
        id: period.id,
        title: period.periods_title,
        period_id: period.period_id,
        type,
      };
      this.vue.$livePlay(course_id, periods_type, params);
    } else if (periods_type == 5 || periods_type == 8) {
      this.vue.$router.push({
        name: 'Video',
        query: {
          course_id: course_id,
          period_id: period.id,
          video_id: period.video_id,
          course_type: periods_type,
        },
      });
    }
  }

  async getPeriodContent(period, system_course_id) {
    let params = {};
    if (system_course_id) {
      params.system_course_id = system_course_id;
    }
    return await this.http.get('/api/app/chapterInfo/' + period.id, params);
  }

  async openPeriodFile(period, id, index, system_course_id) {
    let params = {};
    if (system_course_id) {
      params.system_course_id = system_course_id;
    }
    let data = await this.http.get('/api/app/chapterDatum/' + id + '/' + index, params);
    window.open(data.file_url);
  }

  checkBuyValid(course) {
    if (course.valid_end_time === undefined || course.valid_end_time === -1) {
      return false;
    }
    if (course.valid_end_time === 0) {
      return true;
    }
    return course.valid_end_time * 1000 >= new Date().getTime();
  }
}

export default () => {
  return new CourseService();
};
